import React from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import { avatar1, avatar2 } from '../../assets/images'
import { IconPrinter } from '@tabler/icons-react'

export default function Invoice() {

    return (
        <>
            <Breadcrumb title="Invoice" path="Pages / Invoice" />
            <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                <div className='flex items-start gap-15 justify-between flex-wrap pb-30 mb-30 border-b border-border'>
                    <div className='flex flex-wrap items-start gap-20'>
                        <img src={avatar1} alt='avatar' width="70" height="70" className='w-[70px] h-[70px] rounded-full object-cover' />
                        <div>
                            <p className='text-[16px]/[19.2px] font-medium mb-10'>
                                Michael Truong
                            </p>
                            <p>
                                hello@michaeltruong.ca
                            </p>
                            <p>
                                289-335-6503
                            </p>
                        </div>
                    </div>
                    <div>
                        <div className='text-[24px]/[28.8px] font-medium mb-10'>
                            Invoice #1069
                        </div>
                        <p>
                            Issued: May 27, 2018
                        </p>
                        <p>
                            Payment Due: June 27, 2018
                        </p>
                    </div>
                </div>
                <div className='flex flex-wrap items-start gap-20 mb-20'>
                    <img src={avatar2} alt='avatar' width="70" height="70" className='w-[70px] h-[70px] rounded-full object-cover' />
                    <div>
                        <p className='text-[16px]/[19.2px] font-medium mb-10'>
                            Michael Truong
                        </p>
                        <p>
                            hello@michaeltruong.ca
                        </p>
                        <p>
                            289-335-6503
                        </p>
                        <p className='text-[16px]/[19.2px] font-medium mb-10 mt-20'>
                            Project Description
                        </p>
                        <p>
                            Proin cursus, dui non tincidunt elementum, tortor ex feugiat enim, at elementum enim quam vel purus. Curabitur semper malesuada urna ut suscipit.
                        </p>
                    </div>
                </div>
                <div className='overflow-auto mb-30'>
                    <table className='w-full min-w-[767px]'>
                        <thead>
                            <tr>
                                <th align='left' className='bg-text-primary text-bg-dark p-3'>
                                    #
                                </th>
                                <th align='left' className='bg-text-primary text-bg-dark p-3'>
                                    Description
                                </th>
                                <th align='left' className='bg-text-primary text-bg-dark p-3'>
                                    Hours
                                </th>
                                <th align='left' className='bg-text-primary text-bg-dark p-3'>
                                    Rate
                                </th>
                                <th align='left' width="80px" className='bg-text-primary text-bg-dark p-3'>
                                    Total
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className='p-3 border-t border-border'>
                                    1
                                </td>
                                <td className='p-3 border-t border-border'>
                                    Communication
                                </td>
                                <td className='p-3 border-t border-border'>
                                    5
                                </td>
                                <td className='p-3 border-t border-border'>
                                    $20
                                </td>
                                <td className='p-3 border-t border-border'>
                                    $100
                                </td>
                            </tr>
                            <tr>
                                <td className='p-3 border-t border-border'>
                                    2
                                </td>
                                <td className='p-3 border-t border-border'>
                                    Asset Gathering
                                </td>
                                <td className='p-3 border-t border-border'>
                                    2
                                </td>
                                <td className='p-3 border-t border-border'>
                                    $25
                                </td>
                                <td className='p-3 border-t border-border'>
                                    $50
                                </td>
                            </tr>
                            <tr>
                                <td className='p-3 border-t border-border'>
                                    3
                                </td>
                                <td className='p-3 border-t border-border'>
                                    Design Development
                                </td>
                                <td className='p-3 border-t border-border'>
                                    15
                                </td>
                                <td className='p-3 border-t border-border'>
                                    $10
                                </td>
                                <td className='p-3 border-t border-border'>
                                    $150
                                </td>
                            </tr>
                            <tr>
                                <td className='p-3 border-t border-border'>
                                    4
                                </td>
                                <td className='p-3 border-t border-border'>
                                    Animation
                                </td>
                                <td className='p-3 border-t border-border'>
                                    8
                                </td>
                                <td className='p-3 border-t border-border'>
                                    $10
                                </td>
                                <td className='p-3 border-t border-border'>
                                    $80
                                </td>
                            </tr>
                            <tr>
                                <td className='p-3 border-t border-border'>
                                    5
                                </td>
                                <td className='p-3 border-t border-border'>
                                    Development
                                </td>
                                <td className='p-3 border-t border-border'>
                                    10
                                </td>
                                <td className='p-3 border-t border-border'>
                                    $18
                                </td>
                                <td className='p-3 border-t border-border'>
                                    $18F0
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className='py-20 border-t border-b border-border flex items-start gap-15 lg:flex-row flex-col justify-between'>
                    <div className='w-full max-w-[750px]'>
                        <p className='text-[20px]/[24px] font-medium mb-10'>
                            Note
                        </p>
                        <p>
                            Etsy doostang zoodles disqus groupon greplin oooj voxy zoodles, weebly ning heekya handango imeem plugg dopplr jibjab, movity jajah plickers sifteo edmodo ifttt zimbra.
                        </p>
                    </div>
                    <div className='lg:text-right'>
                        <p>
                            <b>Sub-total : </b>
                            560.00
                        </p>
                        <p>Discout: 12.9%</p>
                        <p>VAT: 12.9%</p>
                        <p className='text-[28px]/[33.6px] font-medium mt-10'>
                            USD 560.00
                        </p>
                    </div>
                </div>
                <div className='flex gap-10 justify-end mt-20'>
                    <button className='btn btn-outline-secondary'>
                        <IconPrinter />
                    </button>
                    <button className='btn btn-primary'>
                        Submit
                    </button>
                </div>
            </div>
        </>
    )
}
